var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"foo"},[_c('div',{staticClass:"red"}),_c('div',{staticClass:"yellow"})]),_c('div',{staticClass:"foo"},[_c('div',{staticClass:"white"}),_c('div',{staticClass:"blue"})])])
}]

export { render, staticRenderFns }